import dayjs from 'dayjs';

import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import LocaleData from 'dayjs/plugin/localeData';
import Weekday from 'dayjs/plugin/weekday';
import CustomParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';

const locale = require(`dayjs/locale/${process.env.VUE_APP_I18N_LOCALE}`);

dayjs.locale({
  ...locale,
  weekStart: 1,
});

dayjs.extend(LocalizedFormat);
dayjs.extend(LocaleData);
dayjs.extend(Weekday);
dayjs.extend(CustomParseFormat);
dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(updateLocale);
dayjs.extend(relativeTime);

export default {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$dayjs', { value: dayjs });
  },
};
